import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
import { useCallback, useState } from 'react';
import { createUriForEditor } from './isModelForEditor';
import { DARK_THEME_NAME, darkTheme, LIGHT_THEME_NAME, lightTheme } from './themes';
const createEditorModel = _ref => {
  let {
    editorName,
    language,
    monaco,
    value
  } = _ref;
  const modelUri = createUriForEditor(monaco, editorName);
  const existingModelWithSameName = monaco.editor.getModel(modelUri);

  // In some cases the model might already exist, and an exception can be thrown
  // This ensures that it is cleaned up and we create a new one with the correct value
  if (existingModelWithSameName != null && !existingModelWithSameName.isDisposed()) {
    existingModelWithSameName.dispose();
  }
  return monaco.editor.createModel(value, language, modelUri);
};
const registerSyntaxThemes = monaco => {
  monaco.editor.defineTheme(LIGHT_THEME_NAME, lightTheme);
  monaco.editor.defineTheme(DARK_THEME_NAME, darkTheme);
};
export const useMonacoInstance = _ref2 => {
  let {
    editorName,
    language,
    monacoEditorOptions,
    value
  } = _ref2;
  const [monacoInstance, setMonacoInstance] = useState();
  const onEditorWillMount = useCallback(monaco => {
    setMonacoInstance(monaco);
    registerSyntaxThemes(monaco);
    const model = createEditorModel({
      editorName,
      language,
      monaco,
      value
    });
    return _objectSpread(_objectSpread({}, monacoEditorOptions), {}, {
      model
    });
  }, [editorName, language, monacoEditorOptions, value]);
  return {
    monacoInstance,
    onEditorWillMount
  };
};